import { ScrollToElement } from './ScrollToElement';

const ERROR_SELECTOR = '.input-group--error, .field-error-message';

export function ScrollToError(scrollTo: ScrollLogicalPosition = 'center') {
	// We need to do this so that it executes after the setErrors is completed
	// otherwise it will execute before the errors are set and not work as intended.
	setTimeout(() => {
		const errors = document.querySelectorAll(ERROR_SELECTOR);
		ScrollToElement(errors, scrollTo);
	}, 0);
}
